document.addEventListener('mouseover', function(e) {
  const color = e.target.closest('.grid-meta-color li');
  if (color && e.target.closest('.grid-meta-color')) {
    const imgObj = color.querySelector('img');
    if(imgObj != null && color.closest('.snippet-product-grid') != null){
      const fullSrc = imgObj.getAttribute('data-full-src') || imgObj.getAttribute('src');
      color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset', fullSrc);
    }
  }
});

document.addEventListener('mouseout', function(e) {
  const color = e.target.closest('.grid-meta-color li');
  if (color && e.target.closest('.grid-meta-color')) {
    if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
      const activeImg = color.closest('.grid-meta-color').querySelector('li a.active img');
      if (activeImg) {
        const fullSrc = activeImg.getAttribute('data-full-src') || activeImg.getAttribute('src');
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset', fullSrc);
      }
    }
  }
});

// Product grid scroll progress bar (for non-arrow instances)
// Accepts an optional root element so it can be scoped to newly-loaded
// Ajaxinate pages without re-processing already-initialised containers.
function initProductGridProgressBars(root) {
  var scope = root || document;
  scope.querySelectorAll('.product-images-scroll').forEach((scrollContainer) => {
    // Skip containers that have already been initialised
    if (scrollContainer.dataset.progressInit) return;
    scrollContainer.dataset.progressInit = '1';

    const progressBar = scrollContainer.parentElement.querySelector('.product-grid-progress-bar');
    if (!progressBar) return;

    const totalImages = parseInt(progressBar.getAttribute('data-total'));
    const segmentWidth = 100 / totalImages;

    // Set fixed width based on number of images
    progressBar.style.width = `${segmentWidth}%`;

    let rafId;
    const updateProgress = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const scrollLeft = scrollContainer.scrollLeft;
        const itemWidth = scrollContainer.querySelector('.product-image-item').offsetWidth;
        if (itemWidth > 0) {
          const currentStep = Math.round(scrollLeft / itemWidth);
          progressBar.style.transform = `translateX(${currentStep * 100}%)`;
        }
      });
    };

    scrollContainer.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  });
}

if (window.innerWidth <= 991) {
  initProductGridProgressBars();
}